<!--
 * @Author: DY
 * @Date: 2025-03-05 15:24:30
 * @LastEditTime: 2025-03-21 18:31:47
 * @Description: 合同查询【销售管理】
 * @FilePath: \ShiMo_Mobile\src\views\sales\contractInquiry\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="contractInquiry commonListStyles">
            <HeaderNav
                header-title="合同查询"
                left-icon-name="2"
                right-icon-name="5"
                :extr="{ leftCallBack: swiperright, rightCallBack: rightClickFun, iconName: 'sm-shaixuan11' }"
            ></HeaderNav>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">合同编号：{{ item.contract_no }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.approval_status_name }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_13@2x.png" alt="">
                                            <span>合同类型：{{ item.contract_type_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_32@2x.png" alt="">
                                            <span>合同模板：{{ item.contract_template_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_1@2x.png" alt="">
                                            <span>客户名称：{{ item.client_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>客户联系人：{{ item.client_contacts }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>合同签订日期：{{ item.creation_time }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <van-button plain type="danger" @click="toDetail(item)">
                                            查看
                                        </van-button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
            <van-popup class="sideslip" v-model="popupShow" position="right" :style="{ width: '80%',height: '100%' }">
                <div class="screen">
                    <van-nav-bar title="筛选" right-text="取消" :style="`height: ${ $getNavHeight() }px;`" @click-right="popupShow = false"></van-nav-bar>
                    <section>
                        <dl>
                            <dt>合同编号</dt>
                            <dd>
                                <van-field v-model="params.contract_no" placeholder="输入汽运单号"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>合同类型</dt>
                            <dd class="selectList">
                                <p v-for="(item, index) in contractTypes" :key="`htlx_${index}`" :class="{'active': item.value === params.contract_type}" @click="params.contract_type = item.value">
                                    {{ item.name }}
                                </p>
                            </dd>
                        </dl>
                        <dl>
                            <dt>合同模板</dt>
                            <dd class="selectList">
                                <p v-for="(item, index) in contractTemplates" :key="`htmb_${index}`" :class="{'active': item.value === params.contract_template}" @click="params.contract_template = item.value">
                                    {{ item.name }}
                                </p>
                            </dd>
                        </dl>
                        <dl>
                            <dt>搜索</dt>
                            <dd>
                                <van-field v-model="params.searchKey" placeholder="输入物料代码"></van-field>
                            </dd>
                        </dl>
                    </section>
                    <footer>
                        <button @click="search">
                            确定
                        </button>
                        <button @click="resetSelect">
                            重置
                        </button>
                    </footer>
                </div>
            </van-popup>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'contract-inquiry',
    mixins: [mixin_list],
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'contract-inquiry');
        }
        next();
    },
    data() {
        return {
            tableCode: 'sales_contract_ledger_query',
            popupShow: false,
            params: {
                contract_no: '',
                contract_type: '',
                contract_template: '',
                searchKey: '',
            },
            contractTypes: [{
                name: '全部',
                value: '',
            }, {
                name: '赊销合同',
                value: '0',
            }, {
                name: '现销合同',
                value: '1',
            }],
            contractTemplates: [{
                name: '全部',
                value: '',
            }, {
                name: '定制合同',
                value: '0',
            }, {
                name: '制式合同',
                value: '1',
            }],
        };
    },
    watch: {},
    activated() {
        if (this.$route.params.isRefresh) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    computed: {},
    methods: {
        rightClickFun() {
            this.popupShow = true;
        },
        loadRequestData() {
            return {
                code: this.tableCode,
                cacheKey: this.cacheKey,
                page: this.pageIndex,
                limit: this.pageSize,
                contract_state: '-2,-1,0',
                contract_no: this.params.contract_no,
                contract_type: this.params.contract_type,
                contract_template: this.params.contract_template,
                searchKey: this.params.searchKey,
            };
        },
        // 确认筛选
        search() {
            this.listData = [];
            this.pageIndex = 0;
            this.finished = false;
            this.popupShow = false;
            this.initPage();
        },
        // 重置筛选条件
        resetSelect() {
            this.params.contract_no = '';
            this.params.contract_type = '';
            this.params.contract_template = '';
            this.params.searchKey = '';
        },
        toDetail(item) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'approvalProcess',
                params: {
                    data: item,
                    isReadOnly: true,
                },
            });
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.contractInquiry
    width 100%
    height 100%
    background #F0F0F0
</style>
